/**
 * @module manifest/panelLayout/table
 * @description Config A：表格（Table）面板布局
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import { type PanelTabLayout } from './types';

const tableBasicGroups = [
  'TableFieldSetting',
  'DescriptionSetting',
  'FreezePanes',
  'MergeSameCells',
  'ChartSwitch',
] as const;

const tableAdvancedGroups = [
  'PivotTable',
  'ConditionalFormat',
  'EditStatistics',
  'PercentageOfColumnTotal',
  'DimensionPercentage',
] as const;

export const TABLE_PANEL_LAYOUT: Partial<Record<TChartType, PanelTabLayout[]>> =
  {
    [ChartType.Table]: [
      { id: 'basic', groups: tableBasicGroups },
      { id: 'advanced', groups: tableAdvancedGroups },
    ],
  };

